import { getCookie } from '../utils/cookie';
import request, { apiURL } from '../utils/api';
class TaskService {
  getAll(propertyId: string, orgId: string) {
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/properties/${propertyId}/activity`, options);
  }

  async removeProspectDuplicate(
    organizationId: string,
    propertyId: string,
    id: string,
  ) {
    const options = {
      method: 'DELETE',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      fullError: true,
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects/duplicates/${id}`,
      options,
    );
  }

  getDuplicateProspects(organizationId: string, propertyId: string) {
    const options = {
      method: 'GET',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects/duplicates`,
      options,
    );
  }

  async mergeProspectDuplicate(
    organizationId: string,
    propertyId: string,
    id: string,
    mergeData: Object,
  ) {
    const options = {
      method: 'POST',
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(mergeData),
      fullError: true,
    };

    return request(
      `${apiURL}/${organizationId}/${propertyId}/prospects/duplicates/${id}/merge`,
      options,
    );
  }
}

export default TaskService;
